export default __webpack_public_path__ + "static/media/pdfauctiontitlebg.9add9bea.png";